<template>
  <div>
    <!-- Table -->
    <v-card>
      <v-card-text class="pt-0">
        <v-data-table
          :headers="headers"
          :items="list"
          class="elevation-0"
          :expanded.sync="expanded"
          show-expand
          single-expand
        >
          <!-- Top -->
          <template v-slot:top>
            <v-toolbar flat color="white">
              <span class="title">Imágenes panorámicas de pala</span>
              <v-spacer/>
              <v-btn small color="primary" @click="show('edit')" v-if="isEditing">Añadir</v-btn>
            </v-toolbar>
          </template>
          <!-- Preview -->
          <template v-slot:item.preview="{ item }">
            <v-img
              v-if="item.panoramic_images && item.panoramic_images.length"
              :src="item.panoramic_images[item.panoramic_images.length - 1].download_url"
              class="cursor-pointer"
              contain aspect-ratio="1"
              max-height="70px"
              @click="show('preview', item.panoramic_images[item.panoramic_images.length - 1])"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0 grey lighten-5" align="center" justify="center" >
                  <v-progress-circular indeterminate color="grey"/>
                </v-row>
              </template>
            </v-img>
          </template>
          <!-- Images Row Preview -->
          <template v-slot:expanded-item="{ item, headers }">
            <td :colspan="headers.length">
              <v-row v-if="!item.panoramic_images.length">
                <v-col cols="12" class="text-center">
                  <span class="ma-3 font-weight-bold caption">No tiene imágenes</span>
                </v-col>
              </v-row>
              <v-row align="center" v-else>
                <v-col cols="12" class="text-center">
                  <span class="ma-3 font-weight-bold caption">Imágenes</span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-container class="pt-0">
                    <v-row  class="grey lighten-4">
                      <v-col cols="2" v-for="image in item.panoramic_images" :key="image.id">
                        <v-img
                          :src="image.download_url"
                          class="cursor-pointer ma-3" 
                          contain aspect-ratio="1"
                          max-height="70px"
                          @click="show('preview', image)"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0 grey lighten-5" align="center" justify="center" >
                              <v-progress-circular indeterminate color="grey"/>
                            </v-row>
                          </template>
                        </v-img>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </td>
          </template>
          <!-- Name -->
          <template v-slot:item.name="{ item }">
            <span v-if="item.panoramic_images && item.panoramic_images.length ">{{ item.panoramic_images[item.panoramic_images.length - 1].name }}</span>
          </template>
          <!-- Actions -->
          <template v-slot:item.action="{ item }">
            <v-icon @click="openFile(item.panoramic_images[item.panoramic_images.length - 1].download_url)">mdi-link</v-icon>
            <span v-if="isEditing">
              <!-- <v-icon class="mx-2" :disabled="!item.panoramic_images.length" @click="show('editImage', item.panoramic_images[item.panoramic_images.length - 1])">mdi-image-edit</v-icon> -->
              <v-icon class="mx-2" @click="show('edit', item)">mdi-pencil</v-icon>
              <v-icon @click="show('delete', item)">mdi-delete</v-icon>
            </span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      persistent
      width="700px"
    >
      <v-card v-if="dialog">
        <v-card-title primary-title>
          {{ title }} imágen panorámica
        </v-card-title>
        <v-card-text>
          <v-stepper v-model="step" vertical class="pa-0 elevation-0">

            <!-- Data -->
            <v-stepper-step :step="1" :editable="!isNew">Datos</v-stepper-step>
            <v-stepper-content step="1">
              <v-row justify="space-around">
                <!-- AG Number -->
                <v-col cols="4">
                  <v-text-field
                    v-model="item.wind_turbine"
                    :error-messages="agNumberErrors"
                    label="AG"
                    @blur="$v.item.wind_turbine.$touch()"
                  ></v-text-field>
                </v-col>
                <!-- Blade Number -->
                <v-col cols="4">
                  <v-text-field
                    v-model="item.blade"
                    :error-messages="bladeNumberErrors"
                    label="Pala"
                    @blur="$v.item.blade.$touch()"
                  ></v-text-field>
                </v-col>
                <!-- Blade Side -->
                <v-col cols="4">
                  <v-select
                    :items="options"
                    v-model="item.type"
                    :error-messages="bladeSideErrors"
                    label="Lado pala"
                    @blur="$v.item.type.$touch()"
                  ></v-select>
                </v-col>
              </v-row>
            </v-stepper-content>

            <!-- Images -->
            <v-stepper-step :step="2" :editable="!isNew">Imágenes</v-stepper-step>
            <v-stepper-content step="2">
              <v-row justify="space-around">
                <!-- Image-->
                <!-- <v-col cols="9" v-if="!item.panoramic_images || item.panoramic_images && !item.panoramic_images.length">
                  <v-file-input
                    v-model="file"
                    :error-messages="fileErrors"
                    label="Archivo adjunto"
                    hint="El tamaño del archivo debe ser menor a 20 MB."
                    persistent-hint
                    show-size
                    outlined
                    @blur="$v.file.$touch()"
                  ></v-file-input>
                </v-col> -->
                <v-col cols="12">
                  <image-upload
                    title="Archivos subidos"
                    :items="item.panoramic_images"
                    :loading="loading"
                    :isEditing="isEditing"
                    externalFooter
                    multiple
                    @delete="deleteFile($event)"
                    @save="uploadFile($event, true)"
                  />
                </v-col>
                <!-- Image Preview -->
                <!-- <v-expand-transition>
                  <v-col cols="9" v-if="!!image">
                    <v-img :src="image ? image : item.panoramic_images[item.panoramic_images.length - 1].download_url " contain aspect-ratio="1">
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0 grey lighten-5" align="center" justify="center" >
                          <v-progress-circular indeterminate color="grey"/>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-expand-transition> -->
              </v-row>
            </v-stepper-content>
            
          </v-stepper>
        </v-card-text>
        <!-- Buttons -->
        <v-card-actions>
          <v-spacer/>
          <v-btn text class="mr-4" @click="close('edit')">Cancelar</v-btn>
          <v-btn color="primary" @click="save()">{{ title }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Image Preview -->
    <image-preview
      v-model="previewDialog"
      :item="item"
      @close="close('preview')"
    />

    <!-- Confirmation -->
    <confirmation
      v-model="deleteDialog"
      title="Eliminar imágen panorámica"
      text="Desea eliminar la imágen panorámica"
      :item="item.name"
      @close="close('delete')"
      @confirm="deleteItem()"
    />
  </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload'
import ImagePreview from "@/components/ImagePreview";
import Confirmation from "@/components/Confirmation";
import { validationMixin } from 'vuelidate'
import { required, between } from 'vuelidate/lib/validators'
import Util from "@/util/index";

export default {
  name: 'panoramic-images',
  props: {
    isEditing: { type: Boolean, default: false }
  },
  components: {
    ImageUpload,
    ImagePreview,
    Confirmation
  },
  mixins: [validationMixin],
  validations: {
    item: {
      wind_turbine: { required },
      blade: { required, between: between(1, 3) },
      type: { required },
    },
    file: { required },
  },
  data: () => ({
    expanded: [],
    step: 1,
    dialog: false,
    previewDialog: false,
    deleteDialog: false,
    item: {
      panoramic_images: []
    },
    file: null,
    image: null,
    headers: [
      { text: "", value: "preview", align: "center" },
      { text: "Imagen", value: "name", align: "center" },
      { text: "AG ", value: "wind_turbine", align: "center" },
      { text: "Pala ", value: "blade", align: "center" },
      { text: "Lado pala ", value: "type", align: "center" },
      { text: "Acciones", value: "action", sortable: false, align: "center" }
    ],
    options: ['B.A', 'B.S', 'V.P', 'V.S'],
  }),
  watch: {
    dialog (val) {
      val || this.close('edit')
    },
    file (val) {
      if (val) this.previewFile()
    }
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    isNew () {
      return !this.item.id
    },
    title () {
      return this.isNew ? 'Añadir' : 'Modificar'
    },
    invalid () {
      return this.$v.$invalid && this.$v.$dirty
    },
    list () {
      return this.$store.state.interventions.bladePanoramicImages.list
    },
    agNumberErrors () {
      const errors = []
      if (!this.$v.item.wind_turbine.$dirty) return errors
      !this.$v.item.wind_turbine.required && errors.push('Obligatorio.')
      return errors
    },
    bladeNumberErrors () {
      const errors = []
      if (!this.$v.item.blade.$dirty) return errors
      !this.$v.item.blade.required && errors.push('Obligatorio.')
      !this.$v.item.blade.between && errors.push('Debe ser 1, 2 o 3.')
      return errors
    },
    bladeSideErrors () {
      const errors = []
      if (!this.$v.item.type.$dirty) return errors
      !this.$v.item.type.required && errors.push('Obligatorio.')
      return errors
    },
    fileErrors () {
      const errors = []
      if (!this.$v.file.$dirty) return errors
      !this.$v.file.required && errors.push('Obligatorio.')
      return errors
    },
  },
  methods: {
    openFile (download_url) {
      window.open(download_url, '_blank')
    },
    previewFile() {
      const reader = new FileReader();
      reader.readAsDataURL(this.file)
      reader.onload = () => this.image = reader.result
    },
    async init () {
      const body = {
        work_intervention_id: this.$route.params.id
      }
      await this.$store.dispatch('interventions/bladePanoramicImages/list', body)
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var altText = "cargando la lista de imágenes panoramicas."
            this.errorAlert(error, altText)
          }
        })
    },
    show (dialog, item) {
      this.item = Object.assign({}, item)
      if (dialog === 'edit') this.dialog = true
      if (dialog === 'delete') this.deleteDialog = true
      if (dialog === 'preview') this.previewDialog = true
    },
    close (dialog) {
      if (dialog === 'delete') this.deleteDialog = false
      if (dialog === 'preview') this.previewDialog = false
      if (dialog === 'edit') this.dialog = false
      this.item = {}
      this.file = null
      this.image = null
      this.step = 1
      this.$v.$reset()
    },
    deleteItem () {
      this.loading = true
      let body = {
        id: this.item.id
      }
      this.close('delete')
      this.$store.dispatch(`interventions/bladePanoramicImages/delete`, body)
        .then(() => {
          this.$toast("Imágen borrada correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.init()
        })
        .catch(error => {
          var altText = "borrando la imágen."
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getOne() {
      this.loading = true
      await this.$store.dispatch('interventions/bladePanoramicImages/get', this.item.id)
        .then(response => {
          const data = response.data.data
          this.item = data
        })
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var altText = "cargando la imágen panoramica."
            this.errorAlert(error, altText)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async uploadFile (editedFile, multiple) {
      const tempFile = editedFile || this.file
      const files = multiple ? tempFile : [tempFile]
      console.log("files", files)
      try {
        for (let i=0; i < files.length; i++) {
          this.loading = true
          const file = files[i]
          console.log("file", file)
          let upload = {
            id: this.item.id,
            fileToUpload: file
          }
          await this.$store.dispatch('interventions/bladePanoramicImages/uploadFile', upload)
        }
        this.$toast("Imágen subida correctamente.", {
          color: "success",
          x: "center",
          y: "top",
          icon: "mdi-information"
        });
      } catch (error) {
        var altText = "subiendo la imágen."
        this.errorAlert(error, altText)
      } finally {
        this.$store.commit('uploading', 0)
        this.loading = false
        this.file = null
        this.init()
        this.getOne()
      }
    },
    deleteFile (file) {
      file.blade_panoramic_image_id = this.item.id
      this.loading = true
      this.$store.dispatch('interventions/bladePanoramicImages/deleteFile', file)
        .then(() => {
          this.$toast("Imágen borrada correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.init()
          this.getOne()
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error borrando la imágen."
          Util.showErrorToast(this, error, errorToastMessage);
        })
        .finally(() => {
          this.loading = false
        })
    },
    save () {
      this.$v.item.$touch()
      if (!this.$v.item.$invalid) this.isNew ? this.create() : this.edit()
    },
    create () {
      this.loading = true
      const body = {
        ...this.item,
        work_intervention_id: this.$route.params.id
      }
      this.$store.dispatch('interventions/bladePanoramicImages/create', body)
        .then(res => {
          this.$toast("Imágen panorámica creada correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.init()
          this.item = res.data.data
          this.step++
        })
        .catch(error => {
          let altText = "creando la imágen panorámica."
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit () {
      this.loading = true
      const body = {
        ...this.item
      }
      if (this.file) this.uploadFile()
      this.close('edit')
      this.$store.dispatch('interventions/bladePanoramicImages/edit', body)
        .then(() => {
          this.$toast("Imágen panorámica modificada correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.init()
        })
        .catch(error => {
          let altText = "editando la imágen panorámica."
          this.errorAlert(error, altText)
        })
        .finally(() => {
          this.loading = false
        })
    },
    errorAlert (error, altText) {
      if (error.response.status === 403 ) {
        this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
          color: "error",
          x: "center",
          y: "top",
          icon: "mdi-information",
          timeout: 0,
          showClose: true,
          closeText: "Cerrar"
        });
        this.$router.push({ name: 'home'})
      } else {
        let errorToastMessage = `Ha ocurrido un error ${altText}`
        Util.showErrorToast(this, error, errorToastMessage);
      }
    },
  },
  created () {
    this.init()
  }
}
</script>
